import { Link } from 'react-router-dom';

const PublishingSection = () => {
  const services = [
    { icon: 'ri-shield-check-line', text: 'Copyright + PRO administration' },
    { icon: 'ri-quill-pen-line', text: 'Co-writing and development' },
    { icon: 'ri-music-2-line', text: 'Pitching for major cuts' },
    { icon: 'ri-line-chart-line', text: 'Long-term catalog strategy' },
  ];

  return (
    <section className="bg-cream py-16 sm:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="font-display text-3xl sm:text-5xl md:text-6xl font-black text-leather-dark mb-4 sm:mb-6 uppercase">
            Publishing Division
          </h2>
          <div className="w-16 sm:w-24 h-1 bg-orange-burnt mx-auto mb-6 sm:mb-8"></div>
          <p className="font-sans text-base sm:text-xl text-leather-dark/80 max-w-3xl mx-auto leading-relaxed">
            Great songs are assets. We build <strong className="font-semibold text-leather-dark">catalogs that last</strong>.
          </p>
        </div>

        {/* Services Grid */}
        <div className="mb-10 sm:mb-16">
          <h3 className="font-western text-lg sm:text-2xl font-bold text-orange-burnt mb-6 sm:mb-8 text-center uppercase">
            Services Include:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
            {services.map((item, index) => (
              <div
                key={index}
                className="bg-leather-dark/5 border-2 border-leather-dark/20 p-5 sm:p-8 flex items-center gap-3 sm:gap-4 hover:border-orange-burnt transition-all duration-300"
              >
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-orange-burnt/10 border-2 border-orange-burnt flex-shrink-0">
                  <i className={`${item.icon} text-xl sm:text-2xl text-orange-burnt`}></i>
                </div>
                <p className="font-sans text-sm sm:text-base text-leather-dark font-medium">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/contact"
            className="inline-block bg-orange-burnt text-cream px-8 sm:px-12 py-4 sm:py-5 rounded-none font-sans text-sm sm:text-base font-bold uppercase tracking-wider hover:bg-leather-dark hover:border-leather-dark transition-all whitespace-nowrap cursor-pointer border-2 border-orange-burnt"
          >
            Join the Publishing Roster
          </Link>
        </div>
      </div>
    </section>
  );
};

export default PublishingSection;
